export const set_error_boundary = (error) => ({
  type: "SET_ERROR_BOUNDARY",
  payload: error,
});

export const clear_error_boundary = () => ({
  type: "CLEAR_ERROR_BOUNDARY",
});
